import { DamAssets } from './DamAssets';

export class DamOrder {
    constructor() {
        this.order = 'name_asc';
    }

    init() {
        this.actions();
        this.setDefaultOrder();
    }

    actions() {
        document.querySelector('*[data-role=damAssetOrder]').onchange = e => {
            this.order = e.target.value;

            const pageTitle = document.querySelector('h1').innerText;

            // Get the current URL's query string
            const currentUrl = new URL(window.location.href);

            // Set the order parameter
            currentUrl.searchParams.set('order', this.order);

            // Push the new state to the history with the updated URL
            window.history.pushState(
                pageTitle,
                pageTitle,
                currentUrl.pathname + currentUrl.search
            );

            const damAssets = new DamAssets();

            damAssets.assets();
        }
    }

    setDefaultOrder() {
        const currentUrl = new URL(window.location.href);
        const order = currentUrl.searchParams.get('order');
        const orderElement = document.querySelector('*[data-role=damAssetOrder]');
        const pageTitle = document.querySelector('h1').innerText;

        if (order) {
            // The order parameter is set in the URL so use this value
            this.order = order;
            orderElement.value = this.order;
        } else {
            // The order parameter is not set in the URL so use te value in the order select
            this.order = orderElement.value;

            orderElement.dispatchEvent(new Event('change'));
        }

        currentUrl.searchParams.set('order', this.order);

        window.history.pushState(pageTitle, pageTitle, currentUrl);
    }
}
